import debug from "debug";

const isDevelopment = process.env.NODE_ENV === "development";

const isDebugEnabled = isDevelopment;

/**
 * Create a scoped debug logger for a specific component or module
 * @param scope The scope/namespace for the logger
 * @returns A scoped logger object
 */
export function createDebugLogger(scope: string) {
  const scopedDebug = debug(`backstage:app:${scope}`);

  return {
    log: (message: string, ...args: any[]) => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.log(`[${scope}]`, message, ...args);
      }

      scopedDebug(message, ...args);
    },

    warn: (message: string, ...args: any[]) => {
      if (isDevelopment || isDebugEnabled) {
        // eslint-disable-next-line no-console
        console.warn(`[${scope}]`, message, ...args);
      }
      scopedDebug(`WARN: ${message}`, ...args);
    },

    error: (message: string, error?: any, ...args: any[]) => {
      // Always log errors to console in development
      if (isDevelopment || isDebugEnabled) {
        // eslint-disable-next-line no-console
        console.error(`[${scope}]`, message, error, ...args);
      }
      scopedDebug(`ERROR: ${message}`, error, ...args);
    },

    time: (label: string) => {
      if (isDevelopment || isDebugEnabled) {
        // eslint-disable-next-line no-console
        console.time(`[${scope}] ${label}`);
      }
    },

    timeEnd: (label: string) => {
      if (isDevelopment || isDebugEnabled) {
        // eslint-disable-next-line no-console
        console.timeEnd(`[${scope}] ${label}`);
      }
    },
  };
}
